import { render, staticRenderFns } from "./SettingsPaymentMethods.vue?vue&type=template&id=3c72ebbe"
import script from "./SettingsPaymentMethods.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports